import { Stack } from 'expo-router'
import { topTabBarHeight, useIsTabBarPositionedTop } from '@/src/common/components/TopTabBar'
import { View } from 'react-native'
import { mesaColorNames } from '@/src/common/theme'

type ExpoStackProps = React.ComponentProps<typeof Stack>

function LayoutNav({ ExpoStackProps }: { ExpoStackProps: ExpoStackProps }) {
  return (
    <Stack {...ExpoStackProps} screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" />
    </Stack>
  )
}

// eslint-disable-next-line @typescript-eslint/naming-convention -- Magic export for Expo Router
export const unstable_settings = {
  // Ensure that reloading on `/modal` keeps a back button present.
  initialRouteName: 'index',
}

// See: https://docs.expo.dev/router/advanced/router-settings/
// We might want to verify if this is even necessary in the Mortgage router,
// as I don't think we support deep linking to any of these pages at this point.
export function MortgageLayout({ ExpoStackProps }: { ExpoStackProps: ExpoStackProps }) {
  const isTabBarPositionedTop = useIsTabBarPositionedTop()
  return (
    <View
      style={[
        {
          flex: 1,
          flexDirection: 'column',
          justifyContent: 'center',
          backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
        },
        isTabBarPositionedTop && { paddingTop: topTabBarHeight },
      ]}
    >
      <LayoutNav ExpoStackProps={ExpoStackProps} />
    </View>
  )
}
